import {
  LIST_TARRIF_URL,
  CREATE_TARRIF_URL,
  UPDATE_TARRIF_URL,
  DELETE_TARRIF_URL,
} from "../../constant";
import { resourceRequest } from "../calls";

/* -------- TARRIFS ---------- */
export function doListTarrifs(token, data) {
  return resourceRequest(token, LIST_TARRIF_URL, data);
}

export function doCreateTarrif(token, data) {
  return resourceRequest(token, CREATE_TARRIF_URL, data);
}

export function doUpdateTarrif(token, data) {
  return resourceRequest(token, UPDATE_TARRIF_URL, data);
}

export function doDeleteTarrif(token, data) {
  return resourceRequest(token, DELETE_TARRIF_URL, data);
}
